const sortSymbol = '2Bfq9wtMSZ77LeWu7vJ+Qdf';
const zero = [
  '',
  '0',
  '00',
  '000',
  '0000',
  '00000',
  '000000',
  '0000000',
  '00000000',
  '000000000',
  '0000000000',
  '00000000000',
  '000000000000',
  '0000000000000',
  '00000000000000',
  '000000000000000',
  '0000000000000000',
  '00000000000000000',
  '000000000000000000',
  '0000000000000000000',
  '00000000000000000000',
];
const f = (a) => a;

const MatchFloat = /([0-9]+\.?[0-9]*)/g;
const MatchInteger = /([0-9]+)/g;

function textSort(a, conv = f, int = false) {
  let temp = {};
  for (let i = 0; i < a.length; i++) {
    const data = conv(a[i]);
    if (typeof data === 'number') {
      let t = String(data);
      if (t.length < 20) t = zero[20 - t.length] + t;
      temp[String(data)] = t;
    } else if (typeof data === 'string') {
      let t = data;
      const m = t.match(int ? MatchInteger : MatchFloat);
      if (m !== null) {
        t = t.replace(int ? MatchInteger : MatchFloat, sortSymbol);
        for (let i = 0; i < m.length; i++) {
          t = t.replace(sortSymbol, m[i].length < 20 ? zero[20 - m[i].length] + m[i] : m[i]);
        }
      }
      temp[String(data)] = t;
    } else {
      temp[String(data)] = String(data);
    }
  }
  a.sort((a, b) => {
    const sa = temp[String(conv(a))];
    const sb = temp[String(conv(b))];
    if (sa === sb) return 0;
    return sa > sb ? 1 : -1;
  });
  return a;
}

const propIsNull = (value) => {
  return (
    value === null ||
    value === '' ||
    value === undefined ||
    (Array.isArray(value) && value.length === 0)
  );
};

/**
 * @deprecated
 * 获取选值属性引用的选项
 * @param propData
 * @param dataIndex
 * @param dataType
 * @param matchConfig
 * @param creator
 * @param title 节点标题
 * @returns {*}
 */
const getTempPropEnumOption = ({
  propData,
  dataIndex,
  dataType,
  matchConfig,
  creator,
  title = '',
}) => {
  const enumOptions = [];
  const matchingProp = matchConfig.find((x) => x.index === dataIndex);
  if (matchingProp) {
    const curDataValues = [];
    matchingProp.matchingIndex.map((propIndex) => {
      if (propIndex < 0) {
        if (propIndex === -1) {
          //创建人
          curDataValues.push(creator);
        } else if (propIndex === -3) {
          //标题
          curDataValues.push(title);
        } else {
          curDataValues.push(null);
        }
      } else {
        curDataValues.push(
          typeof propData[propIndex] === 'number'
            ? propData[propIndex].toString()
            : propData[propIndex],
        );
      }
    });
    const matchingValue = [],
      partialMatchingValue = [];
    if (!~curDataValues.findIndex((x) => !x || (Array.isArray(x) && x.length === 0))) {
      matchingProp.matchingValues.map((x) => {
        if (Array.isArray(x.key) && x.key.length === curDataValues.length) {
          let isMatch = true,
            matchCount = 0,
            nullMiss = true;
          for (let index = 0; index < x.key.length; index++) {
            const key = x.key[index];
            const curDataValue = curDataValues[index];
            if (curDataValue === key) {
              matchCount++;
              continue;
            }
            if (Array.isArray(key)) {
              if (
                (Array.isArray(curDataValue) && !curDataValue.find((z) => !~key.indexOf(z))) ||
                ~key.indexOf(curDataValue)
              ) {
                matchCount++;
                continue;
              }
            } else if (
              Array.isArray(curDataValue) &&
              curDataValue.length === 1 &&
              curDataValue[0] === key
            ) {
              matchCount++;
              continue;
            }
            if (propIsNull(curDataValue)) nullMiss = false;
            isMatch = false;
            break;
          }
          if (isMatch) {
            matchingValue.push(x);
          } else if (matchCount && nullMiss) {
            // 只要有一项匹配上，就作为备选项
            partialMatchingValue.push(x);
          }
        }
      });
    }
    const mValues = matchingValue.length
      ? matchingValue
      : partialMatchingValue.length
      ? partialMatchingValue
      : [];
    if (Array.isArray(mValues) && mValues.length) {
      mValues.map((matchingValue) => {
        if (Array.isArray(matchingValue.prop) && matchingValue.prop.length) {
          matchingValue.prop
            .filter((valueProp) => valueProp.type === dataType)
            .map((valueProp) => {
              if (Array.isArray(valueProp.value) && valueProp.value.length) {
                valueProp.value.map((propValue) => {
                  if (!~enumOptions.indexOf(propValue)) {
                    enumOptions.push(propValue);
                  }
                });
              } else if (valueProp.value && !~enumOptions.indexOf(valueProp.value)) {
                enumOptions.push(valueProp.value);
              }
            });
        }
        if (Array.isArray(matchingValue.alternatives) && matchingValue.alternatives.length) {
          matchingValue.alternatives.map((alternative) =>
            alternative
              .filter((valueProp) => valueProp.type === dataType)
              .map((valueProp) => {
                if (Array.isArray(valueProp.value) && valueProp.value.length) {
                  valueProp.value.map((propValue) => {
                    if (!~enumOptions.indexOf(propValue)) {
                      enumOptions.push(propValue);
                    }
                  });
                } else if (!~enumOptions.indexOf(valueProp.value)) {
                  enumOptions.push(valueProp.value);
                }
              }),
          );
        }
      });
    }
  }
  return textSort(enumOptions);
};

module.exports = { getTempPropEnumOption, textSort };
